import React from 'react'
import { ListFilter } from 'lucide-react'

// ButtonWithIcon pinta `svg { fill }`; el estilo en línea lo anula para que el icono quede sólo con trazo.
const icon = ({ style, ...props }) => (
  <ListFilter size={18} style={{ fill: 'none', ...style }} {...props} />
)

export default icon
